import styled from "styled-components";

export const StyledCampus = styled.div`
  .nav-tabs {
    margin-top: 0;
  }
`;
